/**
 * Confirmation-dialog copy shown before clearing a package's Société reward override — the only
 * remaining literal (non-`override`) action the dialog can submit now that "Disable"/"Enable" have
 * their own code paths removed from the UI (the backend keeps those actions for API compatibility;
 * "Ineligible" via an override's `eligible: false` yields the equivalent `ADMIN_INELIGIBLE` status,
 * plus proper eligibility ownership).
 */
export const CLEAR_OVERRIDE_DESCRIPTION =
  "Clears the manual override and recomputes this package's reward from the formula immediately (falls back to the nightly sweep if the pricing service is unavailable).";
